import { message as antMessage } from 'antd';

export const range = (start: number, end: number) => Array.from({length: (end - start + 1)}, (v: number, k) => {
  return v ? k + start : k + start
})

export const toObj = (array: [], key: string) => {
  const result = array.reduce(function(map, obj) {
    map[obj[key]] = obj;
    return map;
  }, {});

  return result;
}

export const secondsToTime = (secs: number) => {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);

    return {
      "h": hours,
      "m": minutes,
      "s": seconds
  };
}

export const pagination = (items: [], page = 1, per_page = 10) => {
  const offset: number = (page - 1) * per_page,
 
  paginatedItems = items.slice(offset).slice(0, per_page),
  total_pages = Math.ceil(items.length / per_page);
  return {
    page: page,
    per_page: per_page,
    pre_page: page - 1 ? page - 1 : null,
    next_page: (total_pages > page) ? page + 1 : null,
    total: items.length,
    total_pages: total_pages,
    data: paginatedItems
  };
}

export const paginationAll = <T>(items: T[] = [], per_page = 6) => {
  const total_pages = Math.ceil(items.length / per_page);
  const pagingItems = []
  if(total_pages >= 1) {
    for (let index = 1; index <= total_pages; index++) {
      const offset = (index - 1) * per_page
      const paginatedItems = items.slice(offset).slice(0, per_page)
      pagingItems.push(paginatedItems)
    }
  }

  return pagingItems
}

export const convertDateForIos = (date: any) => {
  // if(!date) {
  //   return ''
  // }
  const arr = date.split(/[- :]/);
  date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
  return date;
}
export const format2digits = (number: number) => (
  number < 10 ? ('0' + number) : number
)
export const getRandomNumber = (minimum: number, maximum: number) => {
  return Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
}
export const formatNumber = (num: number, demical: string = '.') => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + demical)
}
export const formatKNumber = (num: number) => {
  const isNegative = num < 0;
  const absNum = Math.abs(num);
  
  let result: string;
  
  if(absNum > 999 && absNum < 1000000){
      result = (absNum/1000).toFixed(0) + 'K';
  } else if(absNum >= 1000000){
      result = (absNum/1000000).toFixed(2).replace('.00', '') + 'M';
  } else {
    result = absNum.toFixed(2);
  }
  
  return isNegative ? '-' + result : result;
}
export const filterArray = (array: [], filters: any) => {
  const filterKeys = Object.keys(filters);
  return array.filter(item => {
    // validates all filter criteria
    return filterKeys.every(key => {
      // ignores non-function predicates
      if (typeof filters[key] !== 'function') return true;
      return filters[key](item[key]);
    });
  });
}
export const shuffleArray = <T>(array: T[]) => {
  let currentIndex: number = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}
export const youtubeId = (url: string): string | null => {
  const regex = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|shorts\/))([^?&"'>]+)/i;
  const match = url.match(regex);
  return match ? match[1] : null;
};
export const setCookie = (name: string, value: any) => {
  const expires = new Date()
  const oneDayTime = 24 * 60 * 60 * 1000 // ms
  expires.setTime(expires.getTime() + oneDayTime)
  document.cookie = `${name}=${escape(value)};expires=${expires.toUTCString()}`
}
export const getCookie = (name: string) => {
  const flag = `${name}=`
  const cookies = document.cookie.split(';')
  for (let item of cookies) {
    item = item.trim()
    if (item.indexOf(flag) > -1) {
      return unescape(item.substr(flag.length))
    }
  }
  return ''
}
export const deleteCookie = (name: string) => {
  const expires = new Date()
  const oneDayTime = 24 * 60 * 60 * 1000
  const value = getCookie(name)
  expires.setTime(expires.getTime() - oneDayTime)
  document.cookie = `${name}=${escape(value)};expires=${expires.toUTCString()}`
}
export const urlQuery = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) {
      return decodeURIComponent(r[2])
  }
  return null
}
export const setUrlParam = (name: any, value: any) => {
  var query = window.location.search.substr(1)
  var obj: any = {}
  var arr: any = query.split('&')
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].split('=')
    obj[arr[i][0]] = arr[i][1]
  }
  obj[name] = value;
  var url = JSON.stringify(obj).replace(/["{}]/g, '').replace(/:/g, '=').replace(/,/g, '&')
  var http = 'https:' == document.location.protocol ? 'https://' : 'http://'
  window.history.replaceState(
    {},
    '',
    http + window.location.host + window.location.pathname + '?' + url
  )
}
export const setUrlPath = (path: string) => {
  window.history.replaceState(
    {},
    '',
    window.location.origin + path
  )
}
export const iOS = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}
export const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
export const padToFour = (number: any) => {
  if (number <= 9999) { number = ("000"+number).slice(-4); }
  return number;
}
export const limitWordsInHTML = (htmlString: string, limit: number = 20): string =>  { //Output just a plain string
  // Parse the HTML string into a DOM document
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // Extract text content from the body
  const textContent = doc.body.textContent || '';

  // Remove leading and trailing whitespaces
  const trimmedString = textContent.trim();

  // Split the string into an array of words using whitespaces as the separator
  const wordsArray = trimmedString.split(/\s+/);

  // Slice the array to include only the specified number of words
  const limitedWordsArray = wordsArray.slice(0, limit);

  // Join the array back into a string using a space as the separator
  const limitedString = limitedWordsArray.join(' ');

  return limitedString;
}

export const getYoutubeId = (url: string) => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
};

export const getAllReactions = (reactions: Record<string, string[]>): string[] => {
  if(!!reactions && Object.keys(reactions).length) {
    let allTmpReact: string[] = []
    for (let index = 0; index < Object.keys(reactions).length; index++) {
      const reactKey = Object.keys(reactions)[index];
      
      allTmpReact = [
        ...allTmpReact,
        ...reactions?.[reactKey] || {}
      ]
    }

    return allTmpReact.filter((value, index, array) => array.indexOf(value) === index)
  }

  return []
}

export const getReactionType = (reactions: Record<string, string[]>, userId: string): string => {
  if(!!reactions && Object.keys(reactions).length) {
    for (let index = 0; index < Object.keys(reactions).length; index++) {
      const reactKey = Object.keys(reactions)[index];

      for (let idx = 0; idx < reactions?.[reactKey].length; idx++) {
        const element = reactions?.[reactKey][idx];
        if(element === userId) {
          return reactKey
        }
      }
    }
  }

  return ''
}


export const escapeHtml = (text: string) => {
  var map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  
  return text ? text.replace(/[&<>"']/g, function(m) { return map[m]; }) : '';
}

export const preFilter = (str: string) => { //Vietnamese
  str = str.toLowerCase();
//     We can also use this instead of from line 11 to line 17
//     str = str.replace(/\u00E0|\u00E1|\u1EA1|\u1EA3|\u00E3|\u00E2|\u1EA7|\u1EA5|\u1EAD|\u1EA9|\u1EAB|\u0103|\u1EB1|\u1EAF|\u1EB7|\u1EB3|\u1EB5/g, "a");
//     str = str.replace(/\u00E8|\u00E9|\u1EB9|\u1EBB|\u1EBD|\u00EA|\u1EC1|\u1EBF|\u1EC7|\u1EC3|\u1EC5/g, "e");
//     str = str.replace(/\u00EC|\u00ED|\u1ECB|\u1EC9|\u0129/g, "i");
//     str = str.replace(/\u00F2|\u00F3|\u1ECD|\u1ECF|\u00F5|\u00F4|\u1ED3|\u1ED1|\u1ED9|\u1ED5|\u1ED7|\u01A1|\u1EDD|\u1EDB|\u1EE3|\u1EDF|\u1EE1/g, "o");
//     str = str.replace(/\u00F9|\u00FA|\u1EE5|\u1EE7|\u0169|\u01B0|\u1EEB|\u1EE9|\u1EF1|\u1EED|\u1EEF/g, "u");
//     str = str.replace(/\u1EF3|\u00FD|\u1EF5|\u1EF7|\u1EF9/g, "y");
//     str = str.replace(/\u0111/g, "d");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
  return str;
}

export const slugify = (originalString: string) => {
  const VIETNAMESE_N_ASCII_MAP: ({ [k: string]: string }) = {
    "à": "a", "ả": "a", "ã": "a", "á": "a", "ạ": "a", "ă": "a", "ằ": "a", "ẳ": "a", "ẵ": "a",
    "ắ": "a", "ặ": "a", "â": "a", "ầ": "a", "ẩ": "a", "ẫ": "a", "ấ": "a", "ậ": "a", "đ": "d",
    "è": "e", "ẻ": "e", "ẽ": "e", "é": "e", "ẹ": "e", "ê": "e", "ề": "e", "ể": "e", "ễ": "e",
    "ế": "e", "ệ": "e", "ì": 'i', "ỉ": 'i', "ĩ": 'i', "í": 'i', "ị": 'i', "ò": 'o', "ỏ": 'o',
    "õ": "o", "ó": "o", "ọ": "o", "ô": "o", "ồ": "o", "ổ": "o", "ỗ": "o", "ố": "o", "ộ": "o",
    "ơ": "o", "ờ": "o", "ở": "o", "ỡ": "o", "ớ": "o", "ợ": "o", "ù": "u", "ủ": "u", "ũ": "u",
    "ú": "u", "ụ": "u", "ư": "u", "ừ": "u", "ử": "u", "ữ": "u", "ứ": "u", "ự": "u", "ỳ": "y",
    "ỷ": "y", "ỹ": "y", "ý": "y", "ỵ": "y", "À": "A", "Ả": "A", "Ã": "A", "Á": "A", "Ạ": "A",
    "Ă": "A", "Ằ": "A", "Ẳ": "A", "Ẵ": "A", "Ắ": "A", "Ặ": "A", "Â": "A", "Ầ": "A", "Ẩ": "A",
    "Ẫ": "A", "Ấ": "A", "Ậ": "A", "Đ": "D", "È": "E", "Ẻ": "E", "Ẽ": "E", "É": "E", "Ẹ": "E",
    "Ê": "E", "Ề": "E", "Ể": "E", "Ễ": "E", "Ế": "E", "Ệ": "E", "Ì": "I", "Ỉ": "I", "Ĩ": "I",
    "Í": "I", "Ị": "I", "Ò": "O", "Ỏ": "O", "Õ": "O", "Ó": "O", "Ọ": "O", "Ô": "O", "Ồ": "O",
    "Ổ": "O", "Ỗ": "O", "Ố": "O", "Ộ": "O", "Ơ": "O", "Ờ": "O", "Ở": "O", "Ỡ": "O", "Ớ": "O",
    "Ợ": "O", "Ù": "U", "Ủ": "U", "Ũ": "U", "Ú": "U", "Ụ": "U", "Ư": "U", "Ừ": "U", "Ử": "U",
    "Ữ": "U", "Ứ": "U", "Ự": "U", "Ỳ": "Y", "Ỷ": "Y", "Ỹ": "Y", "Ý": "Y", "Ỵ": "Y"
  };

  if (originalString == null || originalString.length == 0) {
    return 'undefined';
  }
  //ELSE:
  var removedDuplicatedSpacesString = originalString.replace(/\s+/g, " ");
  var removedVietnameseCharsString = "";
  for (var idx = 0; idx < removedDuplicatedSpacesString.length; idx++) {
    var ch = removedDuplicatedSpacesString[idx];
    var alternativeChar = VIETNAMESE_N_ASCII_MAP[ch];
    if (alternativeChar != null) {
      removedVietnameseCharsString += alternativeChar;
    } else {
      removedVietnameseCharsString += ch;
    }
  }
  return removedVietnameseCharsString.toLowerCase()
  .replace(/[^0-9a-zA-Z]/g, "-")
  .replace(/\-+/g, "-");
};

export const urlify = (text: string) => {
  const urlRegex = /([H|h]ttps?:\/\/[^\s]+)/g;
  // return text.replace(urlRegex, (url: string) => {
  //   return '<a href="' + url + '">' + url + '</a>';
  // })
  // or alternatively
  return text.replace(urlRegex, '<a target="_blank" href="$1">$1</a>')
}

export const calcReadingTime = (text: string): number => {
  const words = text.split(/\s/g).length;
  const minutes = words / 200;
  return Math.ceil(minutes);
};

export const toHashtags = (text: string): string => {
  const regex = /#(\w+)/g
  return text.replace(regex, (val: string): string => {
    return `<a href="#" class="hash-tag-url">#${val}</a>`
  })
}

export const imgToBase64 = (file:File):Promise<string> => {
  return new Promise<string> ((resolve,reject)=> {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString() || '');
    reader.onerror = error => reject(error);
  })
}
export const showLogin = (msg = '', state = null) => {
  return 'login'
}

export const showToast = (message: string, timer = 2000) => {
  // Uses Ant Design's message component to show a toast
  // The import { message as antMessage } from 'antd'; should be at the top of the file
  antMessage.open({
    type: 'error',
    content: message,
    duration: timer,
  });
};

export const validateYouTubeURL = (url: string) => {
  const regex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
  return regex.test(url);
};

export const numberToOrdinal = (n: number) =>  {
  const s = ["th", "st", "nd", "rd"],
        v = n % 100;
  return `<span class="ordinal-number">${n}<sup>${(s[(v - 20) % 10] || s[v] || s[0])}</sup></span>`;
}

export const isMobile = () => {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const debounce = (fn: Function, delay: number) => {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}
